import StaticCrumb from '../components/StaticCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const configsRoutes: BreadcrumbRouteConfig = {
    path: '/agents/:agentId/configs',
    breadcrumbs: [
        {
            component: StaticCrumb,
            props: { label: 'Configs', isCurrentPage: true },
        },
    ],
};
